module.exports = __webpack_public_path__ + "img/komplettbank@2x.9622299.png";